<template>
<div :class="`chart completed-observations md-layout-item md-size-${width} md-large-size-${width} md-medium-size-${width} md-small-size-100`">
    <div>
        <h2>{{label}}</h2>

        <div v-if="observations.length" class="chart-inner">
            <ul>
                <li :key="index" v-for="(observation, index) in observations">
                    <span class="blue">{{ observation.coach_firstname }} {{ observation.coach_lastname }}</span> completed <span class="blue">{{ observation.label }}</span> for <span class="blue">{{ observation.learner_firstname }} {{ observation.learner_lastname }}</span> on <span class="blue">{{ parseInt(observation.completed_date) | moment('MM/DD/YYYY') }}</span>
                </li>
            </ul>
        </div>
        <div class="no-result" v-else>
            <p>No observations have been submitted</p>
        </div>
        <div class="spacer">&nbsp;</div>
    </div>
</div>
</template>

<script>
  export default {
    name: "CoachCompletedObservations",
    computed: {},
    mounted() {
    },
    data() {
      let observations = window.drupalSettings.controller.graphs.CoachCompletedObservations.data

      return {
        label: window.drupalSettings.controller.graphs.CoachCompletedObservations.label,
        width: window.drupalSettings.controller.graphs.CoachCompletedObservations.width || 33,
        observations
      };
    },

    methods: {}
  };
</script>
<style lang="scss" scoped>
    .no-result {
        text-align: center;
        color: rgb(30, 53, 86);
        font-family: "Source Sans Pro";
        font-size: 16px;
        font-weight: 600;
        line-height: 21px;
    }
    .completed-observations.completed-observations > div {
        background: none;
        background-color: #ffffff;
        background-image: url('../assets/customer-reviews.svg') !important;
        background-position: top 20px right 20px;
        background-repeat: no-repeat;
    }
    .blue {
        color: #457B9D;
    }
    ul {
        list-style: none;
        
        li {
            &::before {content: "•"; 
                color: #fa7766;
                font-size: 32px;
                position: absolute;
                left: -20px;
                top: 4px;
            }
            position: relative;
            color: rgb(60, 60, 60);
            font-family: "Source Sans Pro";
            font-size: 14px;
            padding: 20px 0;
            border-bottom: 1px solid #e0e0e0;
            &:last-child {
                border-bottom: none;
            }
        }
    }
    .title {
        font-family: "Source Sans Pro" !important;
        font-size: 14px;
        color: rgb(60, 60, 60);
    }

</style>
